<template>
  <div>
    <!-- 詢價需求單編輯主畫面 -->
    <div class="accordion" id="accordionExample">
      <CCard class="w-100" id="headingOne">
        <CCardHeader
          class="header_group"
          data-toggle="collapse"
          data-target="#collapseOne"
          aria-expanded="true"
          aria-controls="collapseOne"
        >
          <strong>{{ headerText }}</strong>
          <div class="accordionBtn"><i class="el-icon-arrow-down"></i></div>
        </CCardHeader>
        <CCardBody
          id="collapseOne"
          class="collapse"
          aria-labelledby="headingOne"
          data-parent="#accordionExample"
        >
          <CNavbar light color="light">
            <CForm>
              <div class="CForminline">
                <div class="quoteNo">
                  <p>{{ $t("Request_Vue.QuoteNo") }}： {{ form.inquiryNo }}</p>
                </div>
                <div class="version">
                  <p>{{ $t("Request_Vue.Version") }}： {{ form.version }}</p>
                </div>
                <div class="date">
                  <p>
                    {{ $t("QuoteInfo_Vue.StartDate") }}：
                    {{ caseStartDate(form) }}
                  </p>
                </div>
                <div :class="requiredCss('factory')">
                  <p>{{ $t("QuoteInfo_Vue.FactoryType") }}：</p>
                  <div
                    v-for="(item, key) in factoryList"
                    :key="'factory_input_' + key"
                  >
                    <!-- :disabled="disableFactory(item)" -->
                    <input
                      type="radio"
                      v-model="form.factoryId"
                      :value="item.factoryId"
                      :disabled="hasUserFactory"
                      @click="getFactoryPurchase(item.factoryId)"
                    />{{ item.factoryCaption }} ({{ item.factoryId }})
                  </div>
                </div>
                <div class="creator">
                  <p>
                    {{ $t("Request_Vue.Applicant") }}： {{ form.applicantName }}
                  </p>
                </div>
                <div :class="requiredCss('extension')">
                  <p>{{ $t("Request_Vue.Extension") }}：</p>
                  <input
                    type="text"
                    maxlength="50"
                    style="width: 500px"
                    v-model="form.applicantExt"
                    :disabled="!isApplicant"
                  />
                </div>
                <div :class="requiredCss('applicant_unit')">
                  <p>{{ $t("Request_Vue.ApplicantDept") }}：</p>
                  <input
                    type="text"
                    maxlength="50"
                    style="width: 500px"
                    v-model="form.applicantDept"
                    :disabled="!isApplicant"
                  />
                </div>
                <div :class="requiredCss('inquiry_name')">
                  <p>{{ $t("Request_Vue.InquiryName") }}：</p>
                  <input
                    type="text"
                    maxlength="200"
                    style="width: 500px"
                    v-model="form.inquiryName"
                    :disabled="!isApplicant"
                  />
                </div>
                <div :class="requiredCss('purchaser')" style="width: 100%">
                  <p>{{ $t("Request_Vue.Purchaser") }}：</p>
                  <Select2
                    style="width: 30%"
                    class="purchase_input"
                    v-model="form.purchase"
                    :options="FactoryPurchase"
                    :settings="{
                      multiple: false,
                      width: '100%',
                      allowClear: true,
                    }"
                    :disabled="!isApplicant || !form.factoryId"
                  />
                </div>
                <div class="status_code">
                  <p>{{ $t("Request_Vue.Status") }}：</p>
                  <div
                    v-for="(item, key) in statusCodeList"
                    :key="'statusCode_input_' + key"
                  >
                    <input
                      type="radio"
                      name="statusCode_input"
                      v-model="form.status"
                      :value="item.statusCodeId"
                      disabled
                    />{{ item.statusCodeCaption }}
                  </div>
                </div>
                <div :class="requiredCss('demand_purpose')">
                  <p>{{ $t("Request_Vue.DemandPurpose") }}：</p>
                  <input
                    type="text"
                    maxlength="200"
                    style="width: 500px"
                    v-model="form.requestTarget"
                    :disabled="!isApplicant"
                  />
                </div>
                <div :class="requiredCss('demand_date')">
                  <p>{{ $t("Request_Vue.DemandDate") }}：</p>
                  <date-picker
                    :lang="'zh-tw'"
                    v-model="form.requestDate"
                    format="YYYY-MM-DD"
                    valueType="format"
                    :disabled="!isApplicant"
                  ></date-picker>
                </div>
                <div :class="requiredCss('engineer_name')">
                  <p>{{ $t("Request_Vue.EngineerName") }}：</p>
                  <input
                    type="text"
                    maxlength="50"
                    style="width: 500px"
                    v-model="form.principal"
                    :disabled="!isApplicant"
                  />
                </div>
                <div :class="requiredCss('engineer_mail')">
                  <p>{{ $t("Request_Vue.EngineerMail") }}：</p>
                  <input
                    type="text"
                    maxlength="200"
                    style="width: 500px"
                    v-model="form.principalEmail"
                    :disabled="!isApplicant"
                  />
                </div>
                <div class="review">
                  <p>{{ $t("Request_Vue.Review") }}：</p>
                  <div
                    v-for="(item, key) in reviewPlanList"
                    :key="'reviewPlan_input_' + key"
                  >
                    <input
                      type="radio"
                      name="reviewPlan_input"
                      v-model="form.reviewInAdvance"
                      :value="item.reviewPlanId"
                      :disabled="!isApplicant"
                    />{{ item.reviewPlanCaption }}
                  </div>
                </div>
                <div class="supplier">
                  <p>{{ $t("Request_Vue.Supplier") }}：</p>
                  <textarea
                    maxlength="200"
                    rows="3"
                    style="width: 500px"
                    v-model="form.supplier"
                    :disabled="!isApplicant"
                  ></textarea>
                </div>

                <div class="supplier">
                  <p>{{ $t("Request_Vue.PurchaserRemark") }}：</p>
                  <textarea
                    maxlength="200"
                    rows="3"
                    style="width: 500px"
                    v-model="form.purchaseMemo"
                    :disabled="!isApplicant"
                  ></textarea>
                </div>
              </div>
            </CForm>
          </CNavbar>

          <div class="mt-4">
            <div class="text-right mb-2" v-if="isApplicant">
              <button
                type="button"
                class="btn btn-danger mr-2"
                @click="deleteAllModal"
              >
                {{ $t("Request_Vue.DeleteAll") }}
              </button>
              <button
                type="button"
                class="btn btn-primary mr-2"
                @click="importExcelModal"
              >
                Excel{{ $t("Buttons.Import") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="editRequireModal()"
              >
                {{ $t("Buttons.AddNew") }}
              </button>
            </div>

            <table class="table">
              <thead class="thead-light">
                <tr>
                  <th
                    class="text-center"
                    v-for="header in tableHeader"
                    :key="header"
                  >
                    {{ header }}
                  </th>
                  <th class="text-center">
                    {{ i18n("PurchaseInfoTableHeader.Function") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in form.requestDetails" :key="item.id">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.productName }}</td>
                  <td class="text-center">{{ item.spec }}</td>
                  <td class="text-center">{{ item.brand }}</td>
                  <td class="text-center">{{ item.productNo }}</td>
                  <td class="text-center">{{ item.quantity }}</td>
                  <td class="text-center">{{ item.material }}</td>
                  <td class="text-center">{{ item.color }}</td>
                  <td class="text-center">{{ item.equipment }}</td>
                  <td class="text-center">{{ item.comment }}</td>
                  <td class="text-center">{{ item.isPRTxt }}</td>
                  <td class="text-center">{{ item.purchaserNo }}</td>
                  <td class="text-center">{{ item.noPRReason }}</td>
                  <td class="text-center">{{ item.fileQuantity }}</td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-warning mr-2"
                      @click="requireFileModal(index, item)"
                    >
                      {{ i18n("Buttons.Attachments") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-success mr-2"
                      v-if="isApplicant"
                      @click="editRequireModal(index, item)"
                    >
                      {{ i18n("Buttons.Edit") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger mr-2"
                      v-if="isApplicant"
                      @click="deleteRequireModal(index)"
                    >
                      {{ i18n("Buttons.Delete") }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-dark"
                      v-if="
                        form.applicant === $userInfo.account &&
                        (form.status === '結案' ||
                          form.status === '指定結案') &&
                        item.isPR === null
                      "
                      @click="purchaseModal(item.id)"
                    >
                      {{ i18n("Request_Vue.isPR") }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCardBody>
      </CCard>
    </div>

    <CCard
      style="padding: 1rem"
      v-if="form.status !== '需求單位開立中' && form.status !== null && isView"
    >
      <CNavbar light color="light">
        <CForm>
          <div class="CForminline">
            <div :class="requiredCss('purchaser')" style="width: 100%">
              <p>{{ $t("Request_Vue.NotifySupervisor") }}：</p>
              <div
                v-for="(item, key) in reviewPlanList"
                :key="'reviewPlan_input_' + key"
              >
                <input
                  type="radio"
                  name="reviewPlan_input"
                  v-model="form.notifyToSuperior"
                  :value="item.reviewPlanId"
                  :disabled="(!isPurchase && !isAddVersion) || form.isRestart"
                />{{ item.reviewPlanCaption }}
              </div>
            </div>
            <div :class="requiredCss('ask_merchant')">
              <p>{{ $t("Request_Vue.AskMerchant") }}：</p>
              <div
                v-for="(item, key) in merchantList"
                :key="'askMerchant_input_' + key"
              >
                <input
                  type="radio"
                  name="askMerchant_input"
                  v-model="form.inquiryCount"
                  :value="item.askMerchantId"
                  :disabled="(!isPurchase && !isAddVersion) || form.isRestart"
                />{{ item.askMerchantCaption }}
              </div>
              <div v-if="form.inquiryCount === false">
                <span>，{{ $t("Request_Vue.AskMerchantReason") }}：</span>
                <input
                  type="text"
                  maxlength="400"
                  style="width: 500px"
                  v-model="form.inquiryCountReason"
                  :disabled="(!isPurchase && !isAddVersion) || form.isRestart"
                />
              </div>
            </div>
            <div :class="requiredCss('currency')">
              <p>{{ $t("Request_Vue.Currency") }}：</p>
              <el-select
                v-model="form.currency"
                placeholder=""
                :disabled="(!isPurchase && !isAddVersion) || form.isRestart"
              >
                <el-option
                  v-for="item in currencyList"
                  :key="item.Label"
                  :label="item.Label"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </div>
            <div :class="requiredCss('deadline')">
              <p>{{ $t("Request_Vue.Deadline") }}：</p>
              <date-picker
                :lang="lang"
                v-model="form.inquiryEndDate"
                format="YYYY-MM-DD"
                valueType="format"
                :disabled="!isPurchase && !isAddVersion"
                :disabled-date="(date) => date.addDays(1, 'day') <= new Date()"
              ></date-picker>
            </div>

            <div class="supplier">
              <p>{{ $t("Request_Vue.SupplierRemark") }}：</p>
              <textarea
                maxlength="200"
                rows="3"
                style="width: 500px"
                v-model="form.supplierMemo"
                :disabled="!isPurchase && !isAddVersion"
              ></textarea>
            </div>
          </div>
        </CForm>
      </CNavbar>

      <div class="mt-4">
        <div class="text-right mb-2">
          <button
            type="button"
            class="btn btn-success"
            data-toggle="modal"
            data-target="#addVendorModal-M"
            v-if="isPurchase || isAddVersion"
          >
            {{ $t("Buttons.AddNew") }}
          </button>
        </div>

        <table class="table">
          <thead class="thead-light">
            <tr>
              <th
                class="text-center"
                v-for="header in quotationTableHeader"
                :key="header"
              >
                {{ header }}
              </th>
              <th class="text-center" v-if="isPurchase || isAddVersion">
                {{ i18n("PurchaseInfoTableHeader.Function") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in form.requestSuppliers" :key="item.id">
              <!-- <tr v-for="(item, index) in form.vendorList" :key="item.id"> -->
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ item.vendorId }}</td>
              <td class="text-center">{{ item.vendorAbbreviation }}</td>
              <td class="text-center">{{ item.quotationDate }}</td>
              <td
                class="text-center"
                :class="{ red: item.isQuotationTxt === '是' }"
              >
                {{ item.isQuotationTxt }}
              </td>
              <td class="text-center" v-if="isPurchase || isAddVersion">
                <button
                  type="button"
                  class="btn btn-danger mr-2"
                  @click="deleteVendorModal(index)"
                  v-if="!item.quotationEmailNotify"
                >
                  {{ i18n("Buttons.Delete") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </CCard>

    <div class="fixed-bottom">
      <!-- 退件 -->
      <button
        class="btn btn-danger mb-3"
        data-toggle="modal"
        data-target="#rejectModal"
        @click="setReject(form.id)"
        v-if="isCaseReject(form)"
      >
        {{ $t("Buttons.Reject") }}
      </button>

      <!-- 重啟報價 -->
      <button
        class="btn btn-warning mb-3"
        @click="restartRequest(form.id)"
        v-if="
          form.status === '廠商報價中' &&
          form.purchase === $userInfo.account
        "
      >
        {{ i18n("Buttons.RestartQuotation") }}
      </button>

      <!-- 作廢 -->
      <button
        class="btn btn-danger mb-3"
        data-toggle="modal"
        data-target="#deleteModal"
        @click="setInvalidId(form.id)"
        v-if="isCaseInvalid(form)"
      >
        {{ i18n("Buttons.Invalid") }}
      </button>

      <!-- 指定結案 -->
      <button
        class="btn btn-primary mb-3"
        @click="closeCase(form.id)"
        v-if="
          form.purchase === $userInfo.account &&
          form.status === '廠商報價中'
        "
      >
        {{ i18n("Buttons.SettingCloseCase") }}
      </button>

      <button
        class="btn btn-info mb-3"
        @click="saveAddVersion(false)"
        v-if="isAddVersion"
      >
        {{ $t("Buttons.SavedData") }}
      </button>
      <button
        class="btn btn-primary mb-3"
        @click="saveAddVersion(true)"
        v-if="isAddVersion"
      >
        {{ $t("Buttons.Submit") }}
      </button>
      <button
        class="btn btn-info mb-3"
        @click="saveRequest(false)"
        v-if="isApplicant"
      >
        {{ $t("Buttons.SavedData") }}
      </button>
      <button
        class="btn btn-primary mb-3"
        @click="saveRequest(true)"
        v-if="isApplicant"
      >
        {{ $t("Buttons.Submit") }}
      </button>
      <button
        class="btn btn-info mb-3"
        @click="savehByPurchase(false)"
        v-if="isPurchase"
      >
        {{ $t("Buttons.SavedData") }}
      </button>
      <button
        class="btn btn-primary mb-3"
        @click="savehByPurchase(true)"
        v-if="isPurchase"
      >
        {{ $t("Buttons.Submit") }}
      </button>
      <button class="btn btn-dark" to="" @click="goBack">
        {{ $t("Buttons.GoBack") }}
      </button>
    </div>

    <!-- 刪除全部需求 Modal -->
    <div
      class="modal fade"
      id="deleteAllModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">刪除全部需求</div>
          <div class="modal-body">
            <div class="alert-box">
              <div class="alert-icon">!</div>
              是否刪除全部需求
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button type="button" class="btn btn-danger" @click="deleteAll">
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Excel匯入 Modal -->
    <div
      class="modal fade"
      id="importExcelModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">Excel{{ $t("Buttons.Import") }}</div>
          <div class="modal-body">
            <el-form
              :model="importExcelForm"
              :rules="rules"
              ref="importExcelForm"
            >
              <el-form-item label="下載範本檔案" prop="Download">
                <el-button
                  size="small"
                  type="info"
                  plain
                  @click="downloadTemplate"
                  >範本檔</el-button
                >
              </el-form-item>
              <el-form-item label="上傳檔案" prop="Upload">
                <el-upload
                  class="upload-demo"
                  action
                  accept=".xlsx"
                  multiple
                  :file-list="fileImportExcel"
                  :on-change="changeUploadExcel"
                  :auto-upload="false"
                  :on-preview="downloadExcel"
                  :on-remove="removeExcel"
                >
                  <el-button size="small" type="warning" plain>{{
                    i18n("Buttons.SelectFile")
                  }}</el-button>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveExcelFile"
            >
              {{ i18n("Buttons.Import") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/編輯 需求 Modal -->
    <div
      class="modal fade"
      id="editRequireModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">需求項次</div>
          <div class="modal-body">
            <el-form
              :model="addRequireForm"
              :rules="rules"
              ref="addRequireForm"
              label-width="100px"
            >
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    :label="$t('Request_Vue.ProductName')"
                    prop="productName"
                  >
                    <el-input
                      v-model="addRequireForm.productName"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('Request_Vue.Specification')"
                    prop="spec"
                  >
                    <el-input
                      v-model="addRequireForm.spec"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('Request_Vue.Brand')" prop="brand">
                    <el-input
                      v-model="addRequireForm.brand"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('Request_Vue.Type')"
                    prop="productNo"
                  >
                    <el-input
                      v-model="addRequireForm.productNo"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('Request_Vue.Quantity')"
                    prop="quantity"
                  >
                    <el-input
                      type="number"
                      v-model="addRequireForm.quantity"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('Request_Vue.Material')"
                    prop="materia"
                  >
                    <el-input
                      v-model="addRequireForm.material"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="$t('Request_Vue.Color')" prop="color">
                    <el-input
                      v-model="addRequireForm.color"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$t('Request_Vue.Equipment')"
                    prop="equipment"
                  >
                    <el-input
                      v-model="addRequireForm.equipment"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item :label="$t('Request_Vue.Remark')" prop="Remark">
                    <el-input
                      type="textarea"
                      v-model="addRequireForm.comment"
                      maxlength="200"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button type="button" class="btn btn-primary" @click="editRequire">
              {{ i18n("Buttons.SavedData") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 刪除需求 Modal -->
    <div
      class="modal fade"
      id="deleteRequireModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">刪除此需求</div>
          <div class="modal-body">
            <div class="alert-box">
              <div class="alert-icon">!</div>
              是否刪除此項目
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteRequire()"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 需求附件 Modal -->
    <div
      class="modal fade"
      id="requireFileModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">{{ $t("Buttons.Attachments") }}</div>
          <div class="modal-body">
            <el-form
              :model="requireFileForm"
              :rules="rules"
              ref="requireFileForm"
            >
              <el-form-item label="上傳檔案" prop="Upload">
                <el-upload
                  class="upload-demo"
                  action
                  multiple
                  :file-list="fileRequire"
                  :on-change="changeUploadRequire"
                  :auto-upload="false"
                  :on-preview="downloadRequire"
                  :on-remove="removeRequire"
                  :disabled="!isApplicant"
                >
                  <el-button
                    size="small"
                    type="warning"
                    plain
                    v-if="isApplicant"
                    >{{ i18n("Buttons.SelectFile") }}</el-button
                  >
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="saveRequireFile"
              v-if="isApplicant"
            >
              {{ i18n("Buttons.SavedData") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 請轉購 Modal -->
    <div
      class="modal fade"
      id="purchaseModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">{{ $t("Request_Vue.isPR") }}</div>
          <div class="modal-body">
            <el-form
              :model="purchaseForm"
              :rules="rules"
              ref="purchaseForm"
              label-width="120px"
            >
              <el-form-item label="是否回填請購" prop="isPR">
                <el-radio-group v-model="purchaseForm.isPR">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                :label="$t('Request_Vue.PurchaseNo')"
                prop="purchaserNo"
                v-if="purchaseForm.isPR === true"
              >
                <el-input
                  v-model="purchaseForm.purchaserNo"
                  maxlength="50"
                ></el-input>
              </el-form-item>
              <el-form-item
                :label="$t('Request_Vue.NoPRReason')"
                prop="noPRReason"
                v-if="purchaseForm.isPR === false"
              >
                <el-input
                  type="textarea"
                  v-model="purchaseForm.noPRReason"
                  maxlength="200"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button type="button" class="btn btn-primary" @click="purchase">
              {{ i18n("Buttons.SavedData") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增廠商挑選 Modal -->
    <PersonSelect
      @updateVendors="updateVendors"
      :factoryId="form.factoryId"
      :vendorList="form.requestSuppliers"
      :vendorType="'-M'"
    />

    <!-- 刪除廠商 Modal -->
    <div
      class="modal fade"
      id="deleteVendorModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">刪除此廠商</div>
          <div class="modal-body">
            <div class="alert-box">
              <div class="alert-icon">!</div>
              是否刪除此項目
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="deleteVendor()"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- 退件 Modal -->
    <RejectModal @finishReject="finishReject" />

    <!-- 作廢 Modal -->
    <DeleteModal @finishInvalid="finishInvalid" />

  </div>
</template>
<script>
// import PurchaseContent from './PurchaseContent';
import { Notification } from "element-ui";
import PersonSelect from "./PersonSelect";
import RejectModal from "../RequestSearchList/RejectModal";
import DeleteModal from "../RequestSearchList/DeleteModal";
import $ from "jquery";
import { mapGetters, mapActions } from "vuex";
import { requestMixin } from '@/mixin/request'

const getDafaultDeline = () => {
  //--截止日期預設日(+3天 不包含六日)
  let plusDay = 3;
  const weekDay = new Date().getDay();

  if (weekDay > 2 && weekDay < 6) {
    //三~五
    plusDay += 2;
  } else if (weekDay === 6) {
    //六
    plusDay += 1;
  }

  var defaultDelineDate = new Date().addDays(plusDay);
  return defaultDelineDate.yyyymmdd();
};

export default {
  mixins: [requestMixin],
  data() {
    return {
      AskMerchant: "",
      isEdit: true,
      isView: false, // 是否可看報價資訊
      isDisabled: true,
      isApplicant: true, // 是否為填表人
      isPurchase: false, // 是否為採購擔當
      hasUserFactory: true, // 是否有預設廠商
      isAddVersion: false, // 是否為進版號 (採購擔當操作作廢表單)
      tableHeader: [
        // 表格標題
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.ProductName"),
        this.i18n("Request_Vue.Specification"),
        this.i18n("Request_Vue.Brand"),
        this.i18n("Request_Vue.Type"),
        this.i18n("Request_Vue.Quantity"),
        this.i18n("Request_Vue.Material"),
        this.i18n("Request_Vue.Color"),
        this.i18n("Request_Vue.Equipment"),
        this.i18n("Request_Vue.Remark"),
        this.i18n("Request_Vue.isPR"),
        this.i18n("Request_Vue.PurchaseNo"),
        this.i18n("Request_Vue.NoPRReason"),
        this.i18n("Request_Vue.FileQuantity"),
      ],

      currencyList: [
        { Label: "TWD", Id: "TWD" },
        { Label: "CNY", Id: "CNY" },
        { Label: "USD", Id: "USD" },
        { Label: "JPY", Id: "JPY" },
        { Label: "EUR", Id: "EUR" },
        { Label: "KRW", Id: "KRW" },
        { Label: "VND", Id: "VND" },
        { Label: "不限定幣別", Id: "NA" },
      ],
      factoryList: this.$t("factoryRrquestList"), // 廠別 清單
      statusCodeList: this.$t("statusCodeList"), // 表單狀態 清單
      reviewPlanList: this.$t("reviewPlanList"), // 已先行檢討方案 清單
      merchantList: this.$t("merchantList"), // 詢價家數 清單

      quotationTableHeader: [
        // 表格標題
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.QuotationManufacturer"),
        this.i18n("Request_Vue.QuotationManufacturerName"),
        this.i18n("Request_Vue.QuotationDate"),
        this.i18n("Request_Vue.Quotation"),
      ],

      form: {
        vendorList: [],
      },
      formStatus: null,
      formStatusUrl: null, // 從信件進來

      importExcelForm: {},

      addRequireForm: {}, // 新增需求Form
      requireFileForm: {}, // 需求附件Form
      deleteRequireIndex: "", // 刪除需求 Index
      editRequireIndex: "", // 編輯需求 Index
      fileRequireIndex: "", // 附件需求 Index

      purchaseForm: {}, // 請轉購Form

      deleteVendorIndex: "", // 刪除報價廠商 Index

      fileImportExcel: [], // Excel匯入
      fileRequire: [], // 需求附件
      FactoryPurchase: [], // 各廠商採購人員列表

      rules: {
        productName: [{ required: true, message: "必填", trigger: "blur" }],
        spec: [{ required: true, message: "必填", trigger: "blur" }],
        brand: [{ required: true, message: "必填", trigger: "blur" }],
        productNo: [{ required: true, message: "必填", trigger: "blur" }],
        quantity: [{ required: true, message: "必填", trigger: "blur" }],
        isPR: [{ required: true, message: "必填", trigger: "blur" }],
        purchaserNo: [{ required: true, message: "必填", trigger: "blur" }],
        noPRReason: [{ required: true, message: "必填", trigger: "blur" }],
      },
    };
  },
  props: {
    formData: {
      type: Object,
    },
  },
  components: {
    PersonSelect,
    RejectModal,
    DeleteModal,
  },
  computed: {
    // ...mapGetters("purchaseModule", ["procurementOfficerList"]),
    ...mapGetters(["lang"]),

    headerText() {
      if (this.lang === "en") {
        return "Inquiry requirements";
      } else {
        return "詢價需求單";
      }
    },
  },
  methods: {
    // ...mapActions("purchaseModule", ["getProcurementOfficers"]),

    i18n(keyStr) {
      return this.$t(keyStr);
    },

    // 返回
    goBack() {
      this.$router.back();
      // const self = this;
      // if (self.isView) {
      //   self.actionGoBack();
      //   return;
      // }
      // if (!self.isMember && !this.isContentOnlyView) {
      //   if (self.isEdit) {
      //     const row = self.quoteRow;
      //     if (!row.fileName && !row.addFiles) {
      //       this.$alert("無上傳附件檔案，不允許返回!", "警告", {
      //         type: "warning",
      //       });
      //       return;
      //     }
      //   }
      // }
      // this.$confirm("尚未儲存變更的資料，您確定要離開目前的網頁嗎？", "提示", {
      //   confirmButtonText: "是",
      //   cancelButtonText: "否",
      //   type: "warning",
      // })
      //   .then(() => {
      //     self.actionGoBack();
      //   })
      //   .catch(() => {
      //     //console.log("放棄了");
      //   });
    },
    // actionGoBack() {
    //   if (!this.isView) {
    //     const param = {
    //       guid: this.guid,
    //       requestType: this.quoteRow.requestType,
    //     };
    //     if (param.guid && param.requestType) {
    //       //清除，可能上傳匯入的 Excel 資料
    //       const url = `${this.$apiUrl_Quotation}/CancelQuoteData`;
    //       this.axios.post(url, param).then(() => {});
    //     }
    //   }
    //   this.$router.push("/requestsearchlist");
    // },

    // 顯示必填* Fun
    requiredCss(src) {
      if (this.isEdit) {
        return src;
      } else {
        return src + " requiredCss";
      }
    },

    // 開單日期 Fun
    caseStartDate(form) {
      if (this.formStatus === "edit" || this.formStatusUrl === "edit") {
        return form.createTime;
      } else {
        let now = new Date();
        form.createTime =
          now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate();
        return form.createTime;
      }
    },

    // 取得各廠採購人員清單
    getFactoryPurchase(factoryId) {
      // console.log(factoryId);
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/GetFactoryPurchase`;
      let params = { FactoryId: factoryId };

      this.axios.get(api, { params }).then((response) => {
        // console.log("採購人員清單", response.data);
        vm.FactoryPurchase = response.data;
      });
    },

    // 取得 詢價需求單 Detail Api
    getDetail(guid) {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetail`;
      this.updateLoading(true);

      let params = {
        RequestMasterId: guid,
      };

      this.axios.get(api, { params }).then((response) => {
        // console.log("Detail", response);

        let requestSuppliers = [];
        if (response.data.requestSuppliers) {
          requestSuppliers = response.data.requestSuppliers.map((suppliers) => {
            // console.log("suppliers", suppliers);
            let isQuotationTxt = suppliers.isQuotation ? "是" : "否";

            let quotationDate = "";
            if (suppliers.quotationDate) {
              let date = suppliers.quotationDate.split("T");
              quotationDate = date[0];
            }
            return { ...suppliers, isQuotationTxt, quotationDate };
          });
        }

        if (vm.formStatus === "copy") {
          if (
            response.data.purchase === this.$userInfo.account &&
            response.data.status === "作廢" &&
            response.data.voidBySystem
          ) {
            vm.isAddVersion = true;
            vm.isApplicant = false;

            let today = new Date().yyyymmdd();
            let inquiryEndDate = response.data.inquiryEndDate
              ? response.data.inquiryEndDate.substring(0, 10)
              : "";
            let showToday = today > inquiryEndDate;

            let requestDetails = [];
            if (response.data.requestDetails) {
              requestDetails = response.data.requestDetails.map((details) => {
                return {
                  ...details,
                  fileQuantity: details.requestDetailFiles.length,
                };
              });
            }

            vm.form = {
              ...response.data,
              requestSuppliers: requestSuppliers,
              applicant: response.data.applicant,
              inquiryEndDate: showToday
                ? getDafaultDeline()
                : response.data.inquiryEndDate,
              version: response.data.version + 1,
              requestDetails: requestDetails,
            };

            $("#collapseOne").collapse("hide");
          } else {
            vm.isAddVersion = false;

            let requestDetails = response.data.requestDetails.map((details) => {
              // console.log("details", details);
              return {
                ...details,
                isPR: null,
                purchaserNo: "",
                noPRReason: "",
                fileQuantity: details.requestDetailFiles.length,
              };
            });
            // console.log(requestDetails);

            vm.form = {
              ...response.data,
              createTime: response.data.createTime.substring(0, 10),
              requestDetails: requestDetails,
              requestSuppliers: requestSuppliers,
              inquiryNo: "", // 狀態為作廢時單號為原始單號
              version: "",
              factoryId: vm.$userInfo.userFactory,
              applicant: vm.$userInfo.account,
              status: null,
            };
            $("#collapseOne").collapse("show");
          }
        } else {
          let requestDetails = response.data.requestDetails.map((details) => {
            // console.log("details", details.isPR);
            if (vm.formStatus === "copy") {
            } else {
              let isPRTxt = details.isPR
                ? "是"
                : details.isPR === false
                ? "否"
                : "";
              return {
                ...details,
                isPRTxt,
                fileQuantity: details.requestDetailFiles.length,
              };
            }
          });

          vm.form = {
            ...response.data,
            applicant: response.data.applicant,
            createTime: response.data.createTime.substring(0, 10),
            requestDetails: requestDetails,
            requestSuppliers: requestSuppliers,
          };

          if (
            response.data.applicant === this.$userInfo.account &&
            vm.form.status === "需求單位開立中"
          ) {
            vm.isApplicant = true;
          } else {
            vm.isApplicant = false;
          }

          if (
            vm.form.purchase === this.$userInfo.account &&
            (vm.form.status === "需求單位已確認" ||
              vm.form.status === "採購單位處理中")
          ) {
            vm.form.inquiryEndDate = vm.form.inquiryEndDate
              ? vm.form.inquiryEndDate
              : getDafaultDeline();

            vm.form.notifyToSuperior = vm.form.notifyToSuperior
              ? vm.form.notifyToSuperior
              : false;

            if (vm.form.inquiryCount === null) {
              vm.form.inquiryCount = true;
            } else {
              vm.form.inquiryCount = vm.form.inquiryCount;
            }
            // vm.form.inquiryCount = !vm.form.inquiryCount
            //   ? vm.form.inquiryCount
            //   : true;

            let currency = "";
            if (
              this.$userInfo.userFactory === "SZ" ||
              this.$userInfo.userFactory === "NJ" ||
              this.$userInfo.userFactory === "GZ"
            ) {
              currency = "CNY";
            } else if (this.$userInfo.userFactory === "VH") {
              currency = "VND";
            } else {
              currency = "NA";
            }
            vm.form.currency = vm.form.currency ? vm.form.currency : currency;

            vm.isPurchase = true;
          } else {
            vm.isPurchase = false;
          }

          vm.getFactoryPurchase(vm.form.factoryId);
        }

        $("#collapseOne").collapse("show");

        this.updateLoading(false);
      });
    },

    // 刪除 全部需求 Modal
    deleteAllModal() {
      $("#deleteAllModal").modal("show");
    },

    // 刪除 全部需求 Fun
    deleteAll() {
      const vm = this;
      vm.form.requestDetails = [];
      vm.fileRequire = [];
      $("#deleteAllModal").modal("hide");
    },

    // 新增/編輯 需求 Modal
    editRequireModal(index, row) {
      const vm = this;
      if (row) {
        vm.editRequireIndex = index;
        vm.addRequireForm = {
          ...row,
        };
      } else {
        vm.editRequireIndex = "";
        vm.addRequireForm = {};
        vm.$refs.addRequireForm.clearValidate();
      }
      $("#editRequireModal").modal("show");
    },

    // 新增/編輯 需求 Fun
    editRequire() {
      const vm = this;
      vm.$refs.addRequireForm.validate((valid) => {
        if (valid) {
          let params = {
            ...vm.addRequireForm,
          };

          if (vm.editRequireIndex !== "") {
            vm.form.requestDetails[vm.editRequireIndex] = {
              ...params,
            };

            vm.form.requestDetails = vm.form.requestDetails.map((item) => {
              return {
                ...item,
              };
            });
          } else {
            vm.form.requestDetails.push({
              ...params,
              index: vm.form.requestDetails.length + 1,
              requestDetailFiles: [],
              fileQuantity: "0",
            });
          }
          $("#editRequireModal").modal("hide");
        } else {
          return false;
        }
      });
    },

    // 刪除 需求 Modal
    deleteRequireModal(index) {
      const vm = this;
      vm.deleteRequireIndex = index;
      $("#deleteRequireModal").modal("show");
    },

    // 刪除 需求 Fun
    deleteRequire() {
      const vm = this;
      vm.form.requestDetails.splice(vm.deleteRequireIndex, 1);

      vm.form.requestDetails = vm.form.requestDetails.map((item, index) => {
        return {
          ...item,
          index: index + 1,
        };
      });
      $("#deleteRequireModal").modal("hide");
    },

    // 請轉購 Modal
    purchaseModal(id) {
      const vm = this;
      vm.purchaseForm = {
        id: id,
        isPR: true,
      };
      vm.$refs.purchaseForm.clearValidate();
      $("#purchaseModal").modal("show");
    },

    // 轉請購 Api
    purchase() {
      const vm = this;
      const url = `${this.$baseApiUrl}/RequestMaster/ToPRRequestDetail`;
      const param = { ...vm.purchaseForm };
      vm.$refs.purchaseForm.validate((valid) => {
        if (valid) {
          this.updateLoading(true);
          this.axios.post(url, param).then((response) => {
            // console.log("轉請購", response);
            if (response.status === 200) {
              this.updateLoading(false);
              Notification({
                title: "成功",
                message: "送出成功",
                type: "success",
                duration: 5000,
              });
              vm.getDetail(vm.form.id);
              $("#purchaseModal").modal("hide");
            } else {
              this.updateLoading(false);
              Notification({
                title: "錯誤",
                message: response.data.errorMessage,
                type: "error",
                duration: 5000,
              });
            }
          });
        } else {
          return false;
        }
      });
    },

    ///////////////////////////////   匯入Excel   ///////////////////////////////
    // 匯入 Excel Modal
    importExcelModal() {
      const vm = this;
      vm.fileImportExcel = [];
      $("#importExcelModal").modal("show");
    },
    // 下載範本 Api
    downloadTemplate() {
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/RequestDetailExcelExample`;
      this.updateLoading(true);
      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        // console.log("下載範本", response);
        if (response.data.type === "application/json") {
          let reader = new FileReader();
          reader.readAsText(response.data, "utf-8");
          reader.onload = () => {
            const { ErrorMessage } = JSON.parse(reader.result);
            this.updateLoading(false);
            Notification({
              title: "警告",
              message: ErrorMessage,
              type: "warning",
              duration: 5000,
            });
          };
        } else {
          this.updateLoading(false);

          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = url;
          a.download = "範本檔案.xlsx";
          a.click();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    // 儲存 Excel Api
    saveExcelFile() {
      const vm = this;
      // console.log(vm.fileImportExcel);
      if (vm.fileImportExcel.length > 0) {
        vm.fileImportExcel.forEach((file) => {
          let formData = new FormData();

          formData.append(`file`, file.raw);

          const api = `${this.$baseApiUrl}/RequestMaster/RequestDetailImport`;
          vm.updateLoading(true);

          this.axios
            .post(api, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
              // console.log("上傳Excel", response);
              if (response.data.errorMessage) {
                this.updateLoading(false);
                Notification({
                  title: "錯誤",
                  message: response.data.errorMessage[0],
                  type: "error",
                  duration: 5000,
                });
              } else {
                response.data.map((item) => {
                  vm.form.requestDetails.push({
                    ...item,
                    index: vm.form.requestDetails.length + 1,
                    requestDetailFiles: [],
                    fileQuantity: "0",
                  });
                });
                this.updateLoading(false);
                $("#importExcelModal").modal("hide");
              }
            });
        });
      } else {
        $("#importExcelModal").modal("hide");
      }
    },
    // 上傳檔案 Fun
    changeUploadExcel(file) {
      const vm = this;
      vm.fileImportExcel.push(file);
    },
    // 下載檔案 依檔案guid取得檔案 Api
    downloadExcel(file) {
      console.log(file);
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/GetFile/${file.guid}`;

      vm.axios.get(api, { responseType: "blob" }).then((response) => {
        const filename = decodeURIComponent(
          decodeURIComponent(
            response.headers["content-disposition"].split(
              "filename*=UTF-8''"
            )[1]
          )
        );
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
    },
    // 刪除檔案 Fun
    removeExcel(file) {
      const vm = this;
      vm.fileImportExcel.splice(
        vm.fileImportExcel.findIndex((e) => e.uid === file.uid),
        1
      );
    },
    ///////////////////////////////   需求附件   ///////////////////////////////
    // 需求附件 Modal
    requireFileModal(index, row) {
      const vm = this;
      vm.fileRequire = [];
      vm.fileRequireIndex = index;
      // console.log("requestDetails", row);

      if (row.requestDetailFiles && row.requestDetailFiles.length > 0) {
        vm.fileRequire = row.requestDetailFiles.map((item) => {
          return {
            name: item.fileName ? item.fileName : null,
            id: item.id ? item.id : null,
          };
        });
      } else {
        vm.fileRequire = [];
      }
      $("#requireFileModal").modal("show");
    },
    // 儲存 需求附件 Api
    saveRequireFile() {
      const vm = this;
      // console.log(vm.fileRequire);
      if (vm.fileRequire.length > 0) {
        vm.fileRequire.forEach((file) => {
          let formData = new FormData();
          // console.log(file);
          if (file.raw) {
            formData.append(`file`, file.raw);

            const api = `${this.$baseApiUrl}/RequestMaster/UploadRequestDetail`;
            this.updateLoading(true);

            this.axios
              .post(api, formData, {
                headers: { "Content-Type": "multipart/form-data" },
              })
              .then((response) => {
                // console.log("upload", response);
                if (response.status === 200) {
                  vm.form.requestDetails[
                    vm.fileRequireIndex
                  ].requestDetailFiles.push({
                    fileName: file.name,
                    id: response.data,
                    size: file.size,
                  });

                  // 顯示附件數量
                  vm.form.requestDetails[vm.fileRequireIndex].fileQuantity =
                    vm.form.requestDetails[
                      vm.fileRequireIndex
                    ].requestDetailFiles.length;

                  this.updateLoading(false);
                  $("#requireFileModal").modal("hide");
                } else {
                  this.updateLoading(false);
                  Notification({
                    title: "錯誤",
                    message: response.data.errorMessage,
                    type: "error",
                    duration: 5000,
                  });
                }
              });
          } else {
            // 顯示附件數量
            vm.form.requestDetails[vm.fileRequireIndex].fileQuantity =
              vm.form.requestDetails[
                vm.fileRequireIndex
              ].requestDetailFiles.length;
            $("#requireFileModal").modal("hide");
          }
        });
      } else {
        $("#requireFileModal").modal("hide");
      }
    },
    // 上傳檔案 Fun
    changeUploadRequire(file) {
      const vm = this;
      vm.fileRequire.push(file);
    },
    // 下載檔案 依檔案guid取得檔案 Api
    downloadRequire(file) {
      // console.log(file);
      const vm = this;
      if (file.id) {
        const api = `${this.$baseApiUrl}/RequestMaster/GetFile/${file.id}`;

        vm.axios.get(api, { responseType: "blob" }).then((response) => {
          const filename = decodeURIComponent(
            decodeURIComponent(
              response.headers["content-disposition"].split(
                "filename*=UTF-8''"
              )[1]
            )
          );
          const blob = new Blob([response.data]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.href = url;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(url);
        });
      } else {
        this.$alert("未儲存附件無法下載", "提示", { type: "warning" });
      }
    },
    // 刪除檔案 Fun
    removeRequire(file) {
      // console.log("removeRequire", file);
      const vm = this;
      if (file.id) {
        // 執行順序問題 需let index 才可以刪到一樣的位置
        let index = vm.fileRequire.findIndex((e) => e.id === file.id);
        vm.fileRequire.splice(index, 1);
        // console.log(index);
        vm.form.requestDetails[vm.fileRequireIndex].requestDetailFiles.splice(
          index,
          1
        );
      } else {
        vm.fileRequire.splice(
          vm.fileRequire.findIndex((e) => e.uid === file.uid),
          1
        );
      }
    },

    // 檢核 詢價需求單(自需求單位)參數，都滿足則回傳 true
    checkRequestParam(param) {
      const chkFileds = {
        factoryId: "廠別需選擇",
        applicantExt: "填表人分機需輸入",
        applicantDept: "申請單位需輸入",
        inquiryName: "詢價名稱需輸入",
        purchase: "採購擔當需輸入",
        requestTarget: "需求目的需輸入",
        requestDate: "預計需求日期需選擇",
        principal: "負責工程師姓名需輸入",
        principalEmail: "負責工程師E-mail需輸入",
      };
      for (let fd in chkFileds) {
        let val = param[fd];
        if (val !== false && !val) {
          //無此參數資料
          this.$alert(chkFileds[fd], "警告", { type: "warning" });
          return false;
        }
      }

      if (param.reviewInAdvance && !param.supplier) {
        this.$alert("請輸入參與方案供應商", "警告", { type: "warning" });
        return false;
      }

      if (!(param.requestDetails && param.requestDetails.length > 0)) {
        this.$alert("必須要有需求項次資料", "警告", { type: "warning" });
        return false;
      }
      return true;
    },

    // 儲存 詢價需求單 Api (自需求單位)
    saveRequest(isSend) {
      const vm = this;

      let param = {
        ...vm.form,
        applicant: vm.$userInfo.account,
      };

      if (!this.checkRequestParam(param)) {
        return;
      }

      param.requestDetails = param.requestDetails.map((item) => {
        let requestDetailFileGuids = item.requestDetailFiles.map((id) => {
          // console.log("id", id);
          return id.id;
        });
        return { ...item, requestDetailFileGuids };
      });

      // 新增
      let httpMethod = "post";
      let api = `${this.$baseApiUrl}/RequestMaster/RequestMaster`;

      if (vm.formStatus === "copy") {
        api = `${this.$baseApiUrl}/RequestMaster/DuplicateRequestMaster`;
      } else if (vm.formStatus === "edit" || vm.formStatusUrl === "edit") {
        httpMethod = "patch"; // 編輯
      }
      // console.log(param);

      this.updateLoading(true);
      this.axios[httpMethod](api, param).then(async (response) => {
        // console.log("saveRequest", response);

        if (response.status === 200) {
          this.updateLoading(false);
          if (isSend) {
            // 判斷檔案大小
            let newTotalByte = 0;
            let oldTotalByte = 0;
            vm.form.requestDetails.forEach((item) => {
              item.requestDetailFiles.forEach((id) => {
                // console.log("byte", id);
                if (id.fileLength) {
                  oldTotalByte += id.fileLength;
                }
                if (id.size) {
                  newTotalByte += id.size;
                }
              });
            });

            // console.log("newTotalByte", newTotalByte);
            // console.log("oldTotalByte", oldTotalByte);

            const isLt19M = (oldTotalByte + newTotalByte) / 1024 / 1024 < 19;
            if (!isLt19M) {
              this.$message.error("檔案總大小不得超過 19MB!");
              return;
            } else {
              if (httpMethod === "post") {
                await this.sendRequest(response.data[0]);
              } else {
                await this.sendRequest(vm.form.id);
              }
            }
          } else {
            Notification({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 5000,
            });

            this.$router.push({
              path: "/requestsearchlist",
            });
          }
        } else {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
      });
    },

    // 送出 詢價需求單 Api (自需求單位)
    sendRequest(id) {
      // console.log(id);
      const api = `${this.$baseApiUrl}/RequestMaster/DeliverRequestMaster`;
      const param = { id: id };
      this.updateLoading(true);

      this.axios.post(api, param).then((response) => {
        // console.log("sendRequest", response);
        if (response.status === 200) {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          this.$router.push({
            path: "/requestsearchlist",
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
      });
    },

    ///////////////////////////////   報價廠商   ///////////////////////////////
    // 選擇廠商
    updateVendors(selectedList) {
      const vm = this;

      selectedList.map((item) => {
        // console.log(item);
        vm.form.requestSuppliers.push({
          vendorId: item.vendorId,
          vendorAbbreviation: item.vendorAbbreviation,
        });
      });

      // console.log(vm.form.requestSuppliers);

      // const purchaseId = this.guid;
      // let currency = "TWD";
      // const currentRow = this.form;
      // if ("SZ|NJ|GZ".indexOf(currentRow.factoryId) > -1) {
      //   currency = "CNY";
      // }
      // selectedList.map((item) => {
      //   //補足其他欄位
      //   item.guid = "";
      //   item.quoteGuid = purchaseId;
      //   item.currency = currency;
      //   item.quotation = false;
      //   item.isLowestPrice = false;
      //   item.totalPriceWithoutTax = 0;
      //   currentRow.vendorList.push(item);
      // });
      // this.hadChangedVendorList = true;
    },

    // 刪除 廠商 Modal
    deleteVendorModal(index) {
      const vm = this;
      vm.deleteVendorIndex = index;
      $("#deleteVendorModal").modal("show");
    },

    // 刪除 廠商 Fun
    deleteVendor() {
      const vm = this;
      this.form.requestSuppliers.splice(vm.deleteVendorIndex, 1);
    },

    // 檢核 詢價需求單(自採購擔當)參數，都滿足則回傳 true
    checkByPurchaseParam(param) {
      let chkFileds = "";
      if (param.inquiryCount) {
        chkFileds = {
          notifyToSuperior: "是否通知稽核主管需選擇",
          inquiryCount: "詢價家數需選擇",
          currency: "幣別需選擇",
          inquiryEndDate: "詢價截止日期需輸入",
        };
      } else {
        chkFileds = {
          notifyToSuperior: "是否通知稽核主管需選擇",
          inquiryCount: "詢價家數需選擇",
          inquiryCountReason: "說明原因需輸入",
          currency: "幣別需選擇",
          inquiryEndDate: "詢價截止日期需輸入",
        };
      }

      for (let fd in chkFileds) {
        let val = param[fd];
        if (val !== false && !val) {
          //無此參數資料
          this.$alert(chkFileds[fd], "警告", { type: "warning" });
          return false;
        }
      }
      if (!(param.requestSuppliers && param.requestSuppliers.length > 0)) {
        this.$alert("必須要有報價廠商資料", "警告", { type: "warning" });
        return false;
      } else if (
        param.inquiryCount &&
        param.requestSuppliers &&
        param.requestSuppliers.length < 2
      ) {
        this.$alert("報價廠商至少兩家", "警告", { type: "warning" });
        return false;
      }
      return true;
    },

    // 儲存 詢價需求單 Api (自採購擔當)
    savehByPurchase(isSend) {
      // console.log("自採購擔當", isSend);
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/SaveRequestMasterByPurchase`;

      let requestSuppliers = vm.form.requestSuppliers.map((item) => {
        return {
          vendorId: item.vendorId,
        };
      });

      let param = {
        ...vm.form,
        requestSuppliers: requestSuppliers,
      };
      // console.log(param);

      if (!this.checkByPurchaseParam(param)) {
        return;
      }

      this.updateLoading(true);
      this.axios.patch(api, param).then(async (response) => {
        // console.log("savehByPurchase", response);
        if (response.status === 200) {
          this.updateLoading(false);
          if (isSend) {
            await this.sendByPurchase(vm.form.id);
          } else {
            Notification({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 5000,
            });

            this.$router.push({
              path: "/requestsearchlist",
            });
          }
        } else {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
      });
    },

    // 送出 詢價需求單 Api (自採購擔當)
    sendByPurchase(id) {
      // console.log(id);
      const api = `${this.$baseApiUrl}/RequestMaster/DeliverRequestMasterByPurchase`;
      const param = { id: id };
      this.updateLoading(true);

      this.axios.post(api, param).then((response) => {
        // console.log("sendRequest", response);
        if (response.status === 200) {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          this.$router.push({
            path: "/requestsearchlist",
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
      });
    },

    // 儲存 詢價需求單 進版號 Api (自採購擔當、狀態作廢)
    saveAddVersion(isSend) {
      // console.log("進版號", isSend);
      const vm = this;
      const api = `${this.$baseApiUrl}/RequestMaster/DuplicateRequestMasterByPurchase`;

      let requestSuppliers = vm.form.requestSuppliers.map((item) => {
        return {
          vendorId: item.vendorId,
        };
      });

      let param = {
        // ...vm.form,
        id: vm.form.id,
        notifyToSuperior: vm.form.notifyToSuperior,
        inquiryCount: vm.form.inquiryCount,
        inquiryCountReason: vm.form.inquiryCountReason,
        currency: vm.form.currency,
        inquiryEndDate: vm.form.inquiryEndDate,
        requestSuppliers: requestSuppliers,
      };
      // console.log(param);

      if (!this.checkByPurchaseParam(param)) {
        return;
      }

      this.updateLoading(true);
      this.axios.post(api, param).then(async (response) => {
        // console.log("savehByPurchase", response);
        if (response.status === 200) {
          this.updateLoading(false);
          if (isSend) {
            await this.sendByPurchase(response.data[0]);
          } else {
            Notification({
              title: "成功",
              message: "儲存成功",
              type: "success",
              duration: 5000,
            });

            this.$router.push({
              path: "/requestsearchlist",
            });
          }
        } else {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage,
            type: "error",
            duration: 5000,
          });
        }
      });
    },


    // 退件 Api
    finishReject(val) {
      const url = `${this.$baseApiUrl}/RequestMaster/RejectRequestMaster`;
      const param = { id: this.rejectId, rejectReason: val };

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage[0],
            type: "error",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          this.$router.push({ path: "/requestsearchlist", });
        }
      });
    },
    // 重啟報價 Api
    restartRequest(id) {
      const url = `${this.$baseApiUrl}/RequestMaster/RestartRequestMaster`;
      const param = { id };

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage[0],
            type: "error",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          this.$router.push({ path: "/requestsearchlist", });
        }
      });
    },
    // 作廢 Api
    finishInvalid(val) {
      const url = `${this.$baseApiUrl}/RequestMaster/VoidRequestMaster`;
      const param = { id: this.invalidId, rejectReason: val };

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "錯誤",
            message: response.data.errorMessage[0],
            type: "error",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "送出成功",
            type: "success",
            duration: 5000,
          });

          this.$router.push({ path: "/requestsearchlist", });
        }
      });
    },
    // 指定結案 Api
    closeCase(id) {
      const url = `${this.$baseApiUrl}/RequestMaster/DesignatedRequestMaster`;
      const param = { id };

      this.updateLoading(true);
      this.axios.post(url, param).then((response) => {
        if (response.data.errorMessage) {
          this.updateLoading(false);
          Notification({
            title: "警告",
            message: response.data.errorMessage[0],
            type: "warning",
            duration: 5000,
          });
        } else {
          this.updateLoading(false);
          Notification({
            title: "成功",
            message: "指定結案已完成",
            type: "success",
            duration: 5000,
          });

          this.$router.push({ path: "/requestsearchlist", });
        }
      });
    },
  },
  mounted() {
    const vm = this;

    vm.formStatus = vm.formData.formStatus;
    let statusArr = location.href.split("formStatus=");
    let status = statusArr[1].split("&");
    vm.formStatusUrl = status[0];
    // console.log(vm.formStatusUrl);

    let roleId = vm.$userInfo.roleId;
    if (roleId.indexOf("採購") > -1 || roleId === "詢價") {
      vm.isView = true;
    } else {
      vm.isView = false;
    }

    if (vm.formStatusUrl === "edit") {
      let requestMasterId = sessionStorage.getItem("requestMasterId");
      vm.isEdit = false;
      if (requestMasterId) {
        // 由網站進入編輯
        vm.getDetail(requestMasterId);
      } else {
        // 由信件進入編輯
        let arr = location.href.split("requestMasterId=");
        // sessionStorage.setItem("requestMasterId", arr[1]);
        // let requestMasterId = sessionStorage.getItem("requestMasterId");
        vm.getDetail(arr[1]);
      }
    } else {
      vm.isEdit = false;
      vm.isApplicant = true;
      vm.isPurchase = false;

      if (vm.$userInfo.userFactory) {
        vm.hasUserFactory = true;
        vm.getFactoryPurchase(vm.$userInfo.userFactory);
      } else {
        vm.hasUserFactory = false;
      }

      if (vm.formStatus === "copy") {
        //複製處理
        vm.getDetail(vm.formData.requestMasterId);
      } else {
        //新增處理
        vm.form = {
          inquiryNo: "",
          version: "",
          factoryId: vm.$userInfo.userFactory,
          applicant: vm.$userInfo.account,
          status: null,
          requestDetails: [],
        };
        $("#collapseOne").collapse("show");
      }
    }

    sessionStorage.setItem('Requestedit',true) // 給 詢價需求單 返回判斷
  },
  watch: {
    lang: function () {
      this.tableHeader = [
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.ProductName"),
        this.i18n("Request_Vue.Specification"),
        this.i18n("Request_Vue.Brand"),
        this.i18n("Request_Vue.Type"),
        this.i18n("Request_Vue.Quantity"),
        this.i18n("Request_Vue.Material"),
        this.i18n("Request_Vue.Color"),
        this.i18n("Request_Vue.Equipment"),
        this.i18n("Request_Vue.Remark"),
        this.i18n("Request_Vue.isPR"),
        this.i18n("Request_Vue.PurchaseNo"),
        this.i18n("Request_Vue.NoPRReason"),
      ];

      this.quotationTableHeader = [
        this.i18n("Request_Vue.No"),
        this.i18n("Request_Vue.QuotationManufacturer"),
        this.i18n("Request_Vue.QuotationManufacturerName"),
        this.i18n("Request_Vue.QuotationDate"),
        this.i18n("Request_Vue.Quotation"),
      ];

      this.factoryList = this.$t("factoryRrquestList"); //廠別 清單
      this.statusCodeList = this.$t("statusCodeList"); //表單狀態 清單
      this.reviewPlanList = this.$t("reviewPlanList"); //已先行檢討方案 清單
      this.merchantList = this.$t("merchantList"); //詢價家數 清單
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '~bootstrap/scss/bootstrap.scss';
@import "@/assets/scss/select.scss";

.table tr:nth-child(even) {
  background-color: transparent;
}

.btn-edit {
  background-color: #343b55;
  color: white;
}
.option {
  margin-left: 0.2rem;
  cursor: pointer;
}
.item_list {
  margin-bottom: 5px;
}
.item-select #left-item .item-list .item,
.item-select #right-item .item-list .item {
  display: flex;
  align-items: center;
}
.item-select #left-item .item-list .item input[type="checkbox"],
.item-select #right-item .item-list .item input[type="checkbox"] {
  display: block;
  margin-right: 0.5rem;
}

table th:first-child {
  text-align: center;
  padding: 15px 5px;
}

.btn-secondary {
  color: #fff;
  background-color: gray;
}

.header_group {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header_group button {
  margin-left: 8px;
}
.CForminline {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  > .quoteNo,
  .version,
  .factory,
  .date,
  .creator,
  .extension,
  .applicant_unit,
  .inquiry_name,
  .purchaser,
  .status_code,
  .demand_purpose,
  .demand_date,
  .engineer_name,
  .engineer_mail,
  .review,
  .supplier,
  .currency,
  .ask_merchant,
  .deadline {
    display: flex;
    align-items: center;
    margin: 0.5rem 0;

    > p {
      margin-right: 1rem;
      margin-bottom: 0;
    }

    > input {
      margin: 0 0.5rem;
    }

    > span {
      margin: 0 0.5rem;
    }

    > div {
      margin: 0 0.5rem;
    }
  }

  > .purchase_info {
    > p:first-child {
      margin: 0;
    }
    > p {
      margin: 0 0.5rem;
    }
  }
}

.select2-container {
  display: block !important;
  width: 100% !important;
}

.factory_group,
.class {
  > input[type="radio"] {
    margin-left: 0.5rem;
  }
}

.fixed-bottom {
  left: auto;
  right: 10px;
  bottom: 10%;

  > .btn {
    width: 50px;
    height: 50px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 4px;
  }
}

.requiredCss::before {
  content: "*";
  color: #f26161;
  font-weight: bolder;
  margin-bottom: 6px;
}

.requestType-container {
  display: flex;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;

  .requestType {
    margin: 0 0.5rem;

    &:first-child {
      margin-left: 0;
    }

    &:nth-last-child(2) {
      margin-right: 24px;
    }
  }
}

.accordionBtn {
  padding: 5px 25px;
  cursor: pointer;
}

.btn-warning {
  color: #fff;
}

.red {
  color: red;
}
</style>